import React from "react";
import { Lock, Zap } from "lucide-react";
import GlobalDetailDrawer from "modules/swiftboard/components/GlobalDetailDrawer";
import LocalDateTime from "services/date-converter";
import ActiveBadge from "../../../components/ActiveBadge";
import LifecycleBadge from "../../../components/LifecycleBadge";
import { PAYLOAD_TYPE_LABEL, REQUIRED_PAYLOAD_KEYS } from "../features/domain-event.constants";

function PayloadList({ items }) {
  return (
    <ul className="divide-y divide-border rounded-lg border border-border">
      {items.map((item) => (
        <li key={item.key} className="flex items-center justify-between gap-3 px-3 py-2">
          <span className="flex min-w-0 items-center gap-2 text-xs">
            {REQUIRED_PAYLOAD_KEYS.includes(item.key) && <Lock size={12} className="shrink-0 text-text_muted" aria-label="Always included" />}
            <span className="font-mono text-text_primary">{item.key}</span>
            {item.label && item.label !== item.key && <span className="truncate text-text_muted">{item.label}</span>}
          </span>
          <span className="shrink-0 text-[11px] text-text_muted">{PAYLOAD_TYPE_LABEL[item.data_type] ?? item.data_type}</span>
        </li>
      ))}
    </ul>
  );
}

// Read-only view of one domain event (a row of the list, which carries its source).
export default function DomainEventViewDrawer({ record, onClose }) {
  const sections = [
    {
      title: "Event",
      fields: [
        { label: "Name", value: record.name || "—" },
        { label: "Event key", value: <span className="font-mono">{record.event_key}</span> },
        { label: "Source", value: record.source ? `${record.source.label} (${record.source.source_key})` : "—" },
        { label: "Source lifecycle", value: record.source ? <LifecycleBadge status={record.source.status} /> : "—" },
        { label: "Triggers", value: record.trigger_count ?? 0 },
        { label: "Sort order", value: record.sort_order ?? 0 },
        { label: "Status", value: <ActiveBadge active={record.is_activated} /> },
        { label: "Updated", value: record.updated_date ? <LocalDateTime utcTime={record.updated_date} /> : "—" },
        { label: "Description", value: record.description || "—" },
      ],
    },
    { title: `Payload keys (${(record.payload_schema ?? []).length})`, fields: [{ value: <PayloadList items={record.payload_schema ?? []} /> }] },
  ];

  return <GlobalDetailDrawer open onClose={onClose} title={record.name || "Domain event"} subtitle={record.event_key} icon={<Zap size={20} />} sections={sections} />;
}
